import { reduxForm } from 'redux-form'
import { APPOINTMENT_FORM_NAME } from 'constant'
import DateTimeSelector from './DateTimeSelector'
import validate from './validate'

export default reduxForm({
  validate,
  form: APPOINTMENT_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(DateTimeSelector)
